"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecuredByQwilr = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var c = (0, BemBuilder_1.default)("secured-by-qwilr");
var SecuredByQwilr = (function (_super) {
    __extends(SecuredByQwilr, _super);
    function SecuredByQwilr() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SecuredByQwilr.prototype.render = function () {
        var _a = this.props, utmParams = _a.utmParams, onClick = _a.onClick;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c()) },
            react_1.default.createElement("a", { className: (0, classnames_1.default)(c("security-badge"), "kl-link"), href: "https://qwilr.com/trust-and-security".concat(!!utmParams ? "?".concat(utmParams) : ""), rel: "noopener noreferrer", target: "_blank", onClick: onClick },
                react_1.default.createElement("svg", { width: "32", height: "32", fill: "none", viewBox: "0 0 32 32" },
                    react_1.default.createElement("path", { fill: "#00A99D", d: "M8.652 20.005l1.854 2.825a.788.788 0 00.29.267.814.814 0 001.061-.267l4.14-6.56-3.078-4.89-4.292 6.993a1.515 1.515 0 00.025 1.632z" }),
                    react_1.default.createElement("path", { fill: "#EF445A", d: "M23.373 18.373L19.08 11.38l-3.083 4.898 4.144 6.559a.789.789 0 00.29.267.815.815 0 001.061-.267l1.855-2.825a1.53 1.53 0 00.025-1.64z" }),
                    react_1.default.createElement("path", { fill: "#01445A", d: "M17.902 9.458l-1.225-1.89a.788.788 0 00-.29-.269.815.815 0 00-1.065.27l-1.224 1.893-1.18 1.918 3.08 4.898 3.083-4.877-1.178-1.943z" })),
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "xs", className: (0, classnames_1.default)(c("label")) }, "Secured by Qwilr"),
                react_1.default.createElement(icons_1.Security, { size: icons_1.IconSize.Small, className: (0, classnames_1.default)(c("lock-icon")) }))));
    };
    return SecuredByQwilr;
}(react_1.default.Component));
exports.SecuredByQwilr = SecuredByQwilr;
